const Characters = () => {
  return (
    <section className="characters">
      &nbsp;
    </section>
  )
};

export default Characters;